export default {
    joinEvents: 'Join events',
    filter: {
        all: 'All Events',
        virtual: 'Virtual',
        physical: 'Physical',
        hybrid: 'Hybrid',
        myEvents: 'My Events',
    },
    privacy: {
        private: 'Private',
        open: 'Open',
        network: 'Network',
        invite: 'Invite',
    },
    registered: 'Registered',
    register: {
        registerNow: 'Register now',
        spotsLeft: '{n} spots left',
        noSpotsLeft: 'No spots left',
        header: 'You are registered to the event',
        addToCalendar: 'Add to calendar',
        cancel: 'Cancel my registration',
    },
    detailPage: {
        details: 'Details',
        location: 'Event Location',
        link: 'Event Link',
        about: 'About the event',
        live: 'Live',
    },
};
